import React, { useState } from 'react';
import { useEffect } from 'react';
import axios from "axios"
import { isAuth } from '../helpers/auth';

const ExportToExcel = ({ idtheme, codetheme, usser }) => {
  const [evaluacion, setEvaluacion] = useState('')
 
  useEffect(() => {
    getTask()
  }, []);

  const getTask = async () => {
    fetch(`${process.env.REACT_APP_API_URL}/tasks/test/${idtheme}/${codetheme}/${usser}`)
      .then((response) => response.json())
      .then(async (www) => {
        console.log(www[0], "zzz")
        if (www[0]) {
          setEvaluacion(www[0].note)
        }
      })
  };


  return (
    <div>
      <div className='text-center font-weight-bold text-info'>
        Crédito {evaluacion}
      </div>
    </div>
  );
};

export default ExportToExcel